<details class="nhsuk-details" [open]="isDetailsOpen" (toggle)="toggleDetails($event)">
  <summary class="nhsuk-details__summary">
    <span class="nhsuk-details__summary-text font-32"><strong>Filters</strong></span>
  </summary>
  <div class="nhsuk-details__text">
    @if (searchForm) {
      <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
        <div class="grid-3-columns gap-32">
          @if (shouldDisplayField('startDateDoB')) {
            <div
              class="nhsuk-form-group mb-0"
              [class.invalid]="searchForm.controls['startDateDoB'].errors && formSubmitted"
            >
              <label class="nhsuk-label" for="startDateDoB">Date of Birth (From)</label>
              <input
                class="nhsuk-input"
                [class]="{ 'not-empty': isNotEmpty('startDateDoB') }"
                id="startDateDoB"
                name="startDateDoB"
                type="text"
                placeholder="dd/mm/yyyy"
                formControlName="startDateDoB"
              />
              @if (searchForm.controls['startDateDoB'].errors && formSubmitted) {
                <ng-container>
                  <span class="nhsuk-error-message">
                    <span class="nhsuk-u-visually-hidden">Error:</span>
                    The date format should be dd/mm/yyyy
                  </span>
                </ng-container>
              }
            </div>
          }
          @if (shouldDisplayField('endDateDoB')) {
            <div
              class="nhsuk-form-group mb-0"
              [class.invalid]="searchForm.controls['endDateDoB'].errors && formSubmitted"
            >
              <label class="nhsuk-label" for="endDateDoB">Date of Birth (To)</label>
              <input
                class="nhsuk-input"
                [class]="{ 'not-empty': isNotEmpty('endDateDoB') }"
                id="endDateDoB"
                name="endDateDoB"
                type="text"
                placeholder="dd/mm/yyyy"
                formControlName="endDateDoB"
              />
              @if (searchForm.controls['endDateDoB'].errors && formSubmitted) {
                <ng-container>
                  <span class="nhsuk-error-message">
                    <span class="nhsuk-u-visually-hidden">Error:</span>
                    The date format should be dd/mm/yyyy
                  </span>
                </ng-container>
              }
            </div>
          }
          @if (shouldDisplayField('postcode')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="postcode">Postcode</label>
              <input
                class="nhsuk-input"
                [class]="{ 'not-empty': isNotEmpty('postcode') }"
                id="postcode"
                name="postcode"
                type="text"
                formControlName="postcode"
              />
            </div>
          }
          @if (shouldDisplayField('immunisationStatus')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="immunisationStatus"> Immunisation Status</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('immunisationStatus') }"
                id="immunisationStatus"
                name="immunisationStatus"
                formControlName="immunisationStatus"
              >
                <option value="-1" selected>-- Choose a status --</option>
                <option value="NotFully">Not fully immunised</option>
                <option value="Fully">Fully immunised</option>
              </select>
            </div>
          }
          @if (shouldDisplayField('PracticeCode')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="PracticeCode">GP Practice</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('PracticeCode') }"
                id="PracticeCode"
                name="PracticeCode"
                formControlName="PracticeCode"
              >
                <option value="-1" selected>-- Choose a GP Practice --</option>
                @for (practice of practices$ | async; track practice) {
                  <option [value]="practice.value">{{ practice.label }}</option>
                }
              </select>
            </div>
          }
          @if (shouldDisplayField('SchoolYear')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="schoolYear">School year</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('SchoolYear') }"
                id="schoolYear"
                name="schoolYear"
                formControlName="SchoolYear"
              >
                <option value="-2" selected>-- Choose a School year --</option>
                @for (option of dropdownSchoolArray; track option) {
                  <option [value]="option.key">
                    {{ option.value }}
                  </option>
                }
              </select>
            </div>
          }
          @if (shouldDisplayField('AgeGroup')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="AgeGroup">Age group</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('AgeGroup') }"
                id="AgeGroup"
                name="AgeGroup"
                formControlName="AgeGroup"
              >
                <option value="-1" selected>-- Choose an Age group --</option>
                <option value="0-5">0 to 5</option>
                <option value="6-19">6 to 19</option>
              </select>
            </div>
          }
          @if (shouldDisplayField('AgeInYears')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="AgeInYears">Age</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('AgeInYears') }"
                id="AgeInYears"
                name="AgeInYears"
                formControlName="AgeInYears"
              >
                <option value="-1" selected>-- Choose an Age --</option>
                @for (option of dropdownAgeInYears; track option) {
                  <option [value]="option.key">
                    {{ option.value }}
                  </option>
                }
              </select>
            </div>
          }
          @if (shouldDisplayField('sex')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="sex">Sex</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('sex') }"
                id="sex"
                name="sex"
                formControlName="sex"
              >
                <option value="-1" selected>-- Choose a Sex --</option>
                <option value="f">F</option>
                <option value="m">M</option>
              </select>
            </div>
          }
          @if (shouldDisplayField('ethnicity')) {
            @if (ethnicities$ | async; as ethnicities) {
              <div class="nhsuk-form-group mb-0">
                <label class="nhsuk-label" for="ethnicity">Ethnicity</label>
                <select
                  class="nhsuk-select"
                  [class]="{ 'not-empty': isNotEmpty('ethnicity') }"
                  id="ethnicity"
                  name="ethnicity"
                  formControlName="ethnicity"
                >
                  <option value="-1" selected>-- Choose an Ethnicity --</option>
                  @for (ethnicity of ethnicities; track ethnicity) {
                    <option [value]="ethnicity.value">
                      {{ ethnicity.label }}
                    </option>
                  }
                </select>
              </div>
            } @else {
              <app-no-data-select
                fieldName="ethnicity"
                label="Ethnicity"
                [isNotEmpty]="isNotEmpty.bind(this)"
              ></app-no-data-select>
            }
          }
          @if (shouldDisplayField('ward')) {
            @if (wards$ | async; as wards) {
              <div class="nhsuk-form-group mb-0">
                <label class="nhsuk-label" for="ward">Ward</label>
                <select
                  class="nhsuk-select"
                  [class]="{ 'not-empty': isNotEmpty('wardCode') }"
                  id="ward"
                  name="ward"
                  formControlName="wardCode"
                >
                  <option value="-1" selected>-- Choose a Ward --</option>
                  @for (ward of wards; track ward) {
                    <option [value]="ward.value">{{ ward.label }}</option>
                  }
                  <option value="ward-2">Ward 2</option>
                </select>
              </div>
            } @else {
              <app-no-data-select
                fieldName="wardCode"
                label="Ward"
                [isNotEmpty]="isNotEmpty.bind(this)"
              ></app-no-data-select>
            }
          }
          @if (shouldDisplayField('imd')) {
            @if (imds$ | async; as imds) {
              <div class="nhsuk-form-group mb-0">
                <label class="nhsuk-label" for="imd">IMD Decile</label>
                <select
                  class="nhsuk-select"
                  [class]="{ 'not-empty': isNotEmpty('imd') }"
                  id="imd"
                  name="imd"
                  formControlName="imd"
                >
                  <option value="-1" selected>-- Choose an IMD --</option>
                  @for (imd of imds; track imd) {
                    <option [value]="imd.value">{{ imd.label }}</option>
                  }
                </select>
              </div>
            } @else {
              <app-no-data-select
                fieldName="imd"
                label="IMD Decile"
                [isNotEmpty]="isNotEmpty.bind(this)"
              ></app-no-data-select>
            }
          }

          @if (shouldDisplayField('UptoDate')) {

              <div class="nhsuk-form-group missing-vaccine">
                <app-multi-selection
                  [label]="'Up to date'"
                  [itemsArray]="upToDateOptions"
                  [itemsFromUrl]="getUptoDateFromUrl()"
                  (itemsSelectedChange)="onUptoDateItemSelectedChange($event)"
                ></app-multi-selection>
              </div>

          }

          @if (shouldDisplayField('UpToDatePrimary')) {
            <div class="nhsuk-form-group missing-vaccine">
              <app-multi-selection
                [label]="'Up to date Primary'"
                [itemsArray]="upToDateOptions"
                [itemsFromUrl]="getSelectedFromUrl('UpToDatePrimary')"
                (itemsSelectedChange)="onItemsSelectedChange('UpToDatePrimary', $event)"
              ></app-multi-selection>
            </div>
          }
          @if (shouldDisplayField('UpToDate12Month')) {
            <div class="nhsuk-form-group missing-vaccine">
              <app-multi-selection
                [label]="'Up to date Booster'"
                [itemsArray]="upToDateOptions"
                [itemsFromUrl]="getSelectedFromUrl('UpToDate12Month')"
                (itemsSelectedChange)="onItemsSelectedChange('UpToDate12Month', $event)"
              ></app-multi-selection>
            </div>
          }
          @if (shouldDisplayField('UpToDatePreschool')) {
            <div class="nhsuk-form-group missing-vaccine">
              <app-multi-selection
                [label]="'Up to date Pre School'"
                [itemsArray]="upToDateOptions"
                [itemsFromUrl]="getSelectedFromUrl('UpToDatePreschool')"
                (itemsSelectedChange)="onItemsSelectedChange('UpToDatePreschool', $event)"
              ></app-multi-selection>
            </div>
          }
          @if (shouldDisplayField('HasRefusals')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="HasRefusals">Has Refusals</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('HasRefusals') }"
                id="HasRefusals"
                name="HasRefusals"
                formControlName="HasRefusals"
              >
                <option value="-1" selected>-- Has Refusals? --</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          }
          @if (shouldDisplayField('HasSuspensions')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="HasSuspensions">Has Suspensions</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('HasSuspensions') }"
                id="HasSuspensions"
                name="HasSuspensions"
                formControlName="HasSuspensions"
              >
                <option value="-1" selected>-- Has Suspensions? --</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          }
          @if (shouldDisplayField('CurrentCover')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="CurrentCover">Eligible for COVER in the quarter</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('CurrentCover') }"
                id="CurrentCover"
                name="CurrentCover"
                formControlName="CurrentCover"
              >
                <option value="-1" selected>-- Eligible for COVER? --</option>
                <option value="yes">Yes</option>
              </select>
            </div>
          }
          @if (shouldDisplayField('NextCover')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="NextCover">Eligible for Next COVER in the quarter</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('NextCover') }"
                id="NextCover"
                name="NextCover"
                formControlName="NextCover"
              >
                <option value="-1" selected>-- Eligible for Next COVER? --</option>
                <option value="yes">Yes</option>
              </select>
            </div>
          }
          @if (shouldDisplayField('CohortIsNIPE72Hour')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="CohortIsNIPE72Hour">NIPE in 72h</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('CohortIsNIPE72Hour') }"
                id="CohortIsNIPE72Hour"
                name="CohortIsNIPE72Hour"
                formControlName="CohortIsNIPE72Hour"
              >
                <option value="-1" selected>-- NIPE in 72h? --</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          }
          @if (shouldDisplayField('CohortIsGP68WeeksReview')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="CohortIsGP68WeeksReview">GP 6-8 Weeks Review</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('CohortIsGP68WeeksReview') }"
                id="CohortIsGP68WeeksReview"
                name="CohortIsGP68WeeksReview"
                formControlName="CohortIsGP68WeeksReview"
              >
                <option value="-1" selected>-- has GP 6-8 Weeks Review? --</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          }
          @if (shouldDisplayField('CohortIsNewbornBloodSpotScreening')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="CohortIsNewbornBloodSpotScreening">Newborn BloodSpot Screening</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('CohortIsNewbornBloodSpotScreening') }"
                id="CohortIsNewbornBloodSpotScreening"
                name="CohortIsNewbornBloodSpotScreening"
                formControlName="CohortIsNewbornBloodSpotScreening"
              >
                <option value="-1" selected>-- Has Newborn BloodSpot Screening? --</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          }
          @if (shouldDisplayField('CohortIsNewbornHearingScreening')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="CohortIsNewbornHearingScreening">Newborn Hearing Screening</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('CohortIsNewbornHearingScreening') }"
                id="CohortIsNewbornHearingScreening"
                name="CohortIsNewbornHearingScreening"
                formControlName="CohortIsNewbornHearingScreening"
              >
                <option value="-1" selected>-- Has Newborn Hearing Screening? --</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          }
          @if (shouldDisplayField('sciD_Result')) {
            <div class="nhsuk-form-group mb-0">
              <label class="nhsuk-label" for="sciD_Result">SCID Suspected</label>
              <select
                class="nhsuk-select"
                [class]="{ 'not-empty': isNotEmpty('sciD_Result') }"
                id="sciD_Result"
                name="sciD_Result"
                formControlName="sciD_Result"
              >
                <option value="-1" selected>-- SCID Suspected? --</option>
                <option value="Suspected">Yes</option>
                <option value="">No</option>
              </select>
            </div>
          }

          @if (shouldDisplayField('LocalEducationAuthority')) {
            @if (localEducationAuthorities$ | async; as la) {
              <div class="nhsuk-form-group missing-vaccine">
                <app-multi-selection
                  [label]="'Local Education Authority'"
                  [itemsArray]="la"
                  [itemsFromUrl]="getLAFromUrl()"
                  (itemsSelectedChange)="onLAItemSelectedChange($event)"
                >
                </app-multi-selection>
              </div>
            } @else {
              <app-no-data-select
                fieldName="LocalEducationAuthority"
                label="Local Education Authority"
                [isNotEmpty]="isNotEmpty.bind(this)"
              ></app-no-data-select>
            }
          }

          @if (shouldDisplayField('LocalAuthority')) {
            @if (localAuthorities$ | async; as localAuthorities) {
              <div class="nhsuk-form-group missing-vaccine">
                <app-multi-selection
                  [label]="'Local Authority'"
                  [itemsArray]="localAuthorities"
                  [itemsFromUrl]="getLocalAuthorityFromUrl()"
                  (itemsSelectedChange)="onLocalAuthorityItemSelectedChange($event)"
                >
                </app-multi-selection>
              </div>
            } @else {
              <app-no-data-select
                fieldName="LocalAuthority"
                label="Local Authority"
                [isNotEmpty]="isNotEmpty.bind(this)"
              ></app-no-data-select>
            }
          }

          @if (shouldDisplayField('SchoolCode')) {
            @if (schools$ | async; as schools) {
              <div class="nhsuk-form-group missing-vaccine">
                <app-multi-selection
                  [label]="'Schools'"
                  [itemsArray]="schools"
                  [itemsFromUrl]="getSchoolFromUrl()"
                  (itemsSelectedChange)="onSchoolItemSelectedChange($event)"
                ></app-multi-selection>
              </div>
            } @else {
              <app-no-data-select
                fieldName="school"
                label="School"
                [isNotEmpty]="isNotEmpty.bind(this)"
              ></app-no-data-select>
            }
          }

          @if (shouldDisplayField('MissingVaccine')) {
            @if (vaccines$ | async; as vaccines) {
              <div class="nhsuk-form-group missing-vaccine">
                <app-multi-selection
                  [label]="'Missing Vaccines'"
                  [itemsArray]="vaccines"
                  [itemsFromUrl]="getMissingVaccinesFromUrl()"
                  (itemsSelectedChange)="onMissingVaccineItemSelectedChange($event)"
                >
                </app-multi-selection>
              </div>
            } @else {
              <app-no-data-select
                fieldName="MissingVaccine"
                label="Missing Vaccine"
                [isNotEmpty]="isNotEmpty.bind(this)"
              ></app-no-data-select>
            }
          }

          @if (shouldDisplayField('ReasonNotGiven')) {
            @if (refusalReasons$ | async; as refusalReasons) {
              <div class="nhsuk-form-group missing-vaccine">
                <app-multi-selection
                  [label]="'Reason for Vaccine Not Given'"
                  [itemsArray]="refusalReasons"
                  [itemsFromUrl]="getRefusalReasonsFromUrl()"
                  (itemsSelectedChange)="onRefusalReasonsItemSelectedChange($event)"
                >
                </app-multi-selection>
              </div>
            } @else {
              <app-no-data-select
                fieldName="ReasonNotGiven"
                label="Reason for Vaccine Not Given"
                [isNotEmpty]="isNotEmpty.bind(this)"
              ></app-no-data-select>
            }
          }
        </div>
        <br />
        <div class="flex gap-16 mt-30">
          <button class="nhsuk-button" data-module="nhsuk-button" type="submit">Search</button>
          <button class="nhsuk-button nhsuk-button--secondary" type="button" (click)="clearFilters()">
            Clear filters
          </button>
        </div>
      </form>
    }
  </div>
</details>

@if (appliedFilters.length) {
  <div class="applied-filters">
    <p class="applied-filters__title"><strong>Filters applied:</strong></p>
    <ul class="flex wrap gap-24">
      @for (filter of appliedFilters; track filter.key) {
        <li class="flex wrap item-center gap-8">
          <span>{{ filter.label }}:</span>
          @for (value of filter.values; track value) {
            <button type="button" class="applied-filter" (click)="removeFilter(filter.key, value)">
              {{ filterValueLabel(filter.key, value) }}
              <span aria-hidden="true">&times;</span>
              <span class="nhsuk-u-visually-hidden">Remove this filter</span>
            </button>
          }
        </li>
      }
    </ul>
    <button type="button" class="link-button" (click)="clearFilters()">Clear all filters</button>
  </div>
}
